function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var Svg3 = function Svg3(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 92.672 120.003"
  }, props), /*#__PURE__*/React.createElement("path", {
    d: "M-11.674-51.042a23.678 23.678 0 0 1 10.5-2.715c8.326 0 17.014 4.706 17.014 15.928 0 8.688-6.516 16.109-17.557 16.109s-18.462-8.145-18.824-18.462l-27.512 5.068C-46.246-15.023-28.87 2.534-1.539 2.534c28.96 0 46.155-18.824 46.155-39.639 0-20.091-14.842-34.571-32.942-35.838l28.96-22.444v-22.082h-84.708v23.892H4.977l-28.96 23.711z",
    "data-name": "Path 32192",
    style: {
      fill: "#fff3ed"
    },
    transform: "translate(48.056 117.469)"
  }));
};
export default Svg3;